import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebTempTermoExtratoDesligamento } from '../models/WebTempTermoExtratoDesligamento.model';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebTempTermoExtratoDesligamentoService {
  private strAction = 'api/WebTempTermoExtratoDesligamento';

  constructor(private http: HttpClient) {

  }
///api/WebTempTermoExtratoDesligamento/GetById/43

  public getById(idTermo: number): Observable<WebTempTermoExtratoDesligamento> {
    return this.http.get<WebTempTermoExtratoDesligamento>(`${environment.TrustCRMApiHost}api/WebTempTermoExtratoDesligamento/GetById/${idTermo}`);
  }


}
